import '../styles/PlantDetailPopup.css';

const PlantDetailPopup = ({ plant, onClose, onAddToGarden }) => {
  return (
    <div className="plant-pokemon-bookmark-popup detail-overlay">
      <div>
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="plant-pokemon-bookmark">

          <div className="plant-bookmark-leftside">
            <div className="plant-card-bookmark-header">
              <div className="plant-nametag">
                <span className="plant-common-name">{plant.common_name}</span>
                <span className="plant-scientific-name"> {plant.scientific_name}</span>
              </div>

              <div className="plant-build">
                <span className="plant-type">{plant.category}</span>
                <span className="plant-difficulty">{plant.growth_difficulty}</span>
              </div>
            </div>

            <div className="plant-image">
              <img src={plant.representative_image_url} alt={plant.common_name} />
            </div>

            <button
              className="pixel-button add-to-garden-btn"
              onClick={onAddToGarden}
            >
              + Add to garden
            </button>
          </div>

          <div className="plant-recommendations">
            <div className="spec">
              <span className="spec-label">Optimal seasons:</span>
              <span className="spec-value">{plant.optimal_season}
                {/* {plant.seasons.map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(', ')} */}
              </span>
            </div>

            <div className="spec">
              <span className="spec-label">Growing time until harvest:</span>
              <span className="spec-value">{plant.min_days_to_harvest} - {plant.max_days_to_harvest} days</span>
            </div>

            <div className="spec">
              <span className="spec-label">Temperature to grow:</span>
              <span className="spec-value">{plant.min_temperature_c} - {plant.max_temperature_c} °C</span>
            </div>

            <div className="spec">
              <span className="spec-label">Planting conditions:</span>
              <span className="spec-value">{plant.planting_condition}</span>
            </div>

            <div className="spec">
              <span className="spec-label">Watering frequency:</span>
              <span className="spec-value">{plant.watering_frequency_level}: </span>
              <span className="spec-value">{plant.watering_notes}</span>

            </div>

            <div className="spec">
              <span className="spec-label">Fertiliser:</span>
              <span className="spec-value">{plant.fertilizer_notes}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlantDetailPopup;